import {VismaRestkontoDownloadRequest} from 'common/types/store/threeSixtyTypes';
import {VismaResAccState} from '.';

export function toStrictApi(state: VismaResAccState): VismaRestkontoDownloadRequest {
	const result: Partial<VismaRestkontoDownloadRequest> = {};

	if (typeof state.account_id === 'number') result.account_id = state.account_id;
	if (state.format) result.format = state.format;
	if (typeof state.include_all === 'boolean') result.include_all = state.include_all;
	if (typeof state.use_entire_account === 'boolean') result.use_entire_account = state.use_entire_account;
	if (Array.isArray(state.includes) && state.includes.length > 0) result.includes = state.includes;
	if (typeof state.item_id === 'string') result.item_id = state.item_id;
	if (typeof state.client_number === 'number') result.client_number = state.client_number;
	// if (typeof state.isError === 'boolean') result.isError = state.isError;

	return result as VismaRestkontoDownloadRequest;
}